import React from "react";
import {withStyles} from '@material-ui/core';
import ListAllResearchers from "./listAllResearchers";

const styles = () => ({
  root: {
    paddingTop : 30,
    paddingRight : 70,
    paddingLeft : 70,
    paddingBottom : 70,
    textAlign: 'center',
    borderRadius : 0,
    height : "100%",
    minHeight : "100%"
  },
})

class Researchers extends React.Component {
  render() {
    return(
      <div className={this.props.classes.root}>
        <ListAllResearchers/>
      </div>
    );
  }
}

export default withStyles(styles)(Researchers);


// WEBPACK FOOTER //
// ./src/components/researchers/dashboard.js